import { Outlet, useLocation } from 'react-router-dom';
import { CookieBanner } from './CookieConsent';
import { GoogleSiteVerification } from './GoogleSiteVerification';
import { JsonLdSite } from './JsonLdSite';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';
import { SupportDeskChat } from './SupportDeskChat';

export function Layout() {
  const { pathname } = useLocation();

  return (
    <>
      <GoogleSiteVerification />
      <JsonLdSite />
      <a href="#main-content" className="ct-skip-link">
        Spring naar inhoud
      </a>
      <div className="flex min-h-screen flex-col bg-ct-bg text-ct-text">
        <SiteHeader />
        <main
          id="main-content"
          tabIndex={-1}
          className="ct-marketing-bg flex-1 outline-none"
        >
          <div key={pathname} className="ct-page-enter">
            <Outlet />
          </div>
        </main>
        <div className="print:hidden">
          <SiteFooter />
        </div>
      </div>
      <CookieBanner />
      <div className="print:hidden">
        <SupportDeskChat />
      </div>
    </>
  );
}
